import { Card, CardContent, Grid2 } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import Checkbox from 'components/forms/Checkbox'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { mainBlue } from 'utils/constants/ColorTheme'

const CollectivityForm = ({
    collectivity = {},
    readMode = true,
    nbManagementEntities = 0,
    setCollectivity = () => { },
}) => {
    return (
        <Card>
            <CardTitle title={i18n.collectivityDescription} color={mainBlue}/>
            <CardContent>

                <Grid2 container columnSpacing={2}>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.sispeaCode}
                            value={collectivity.sispeaCode}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, sispeaCode: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.headquartersDepartment}
                            value={collectivity.departement}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, departement: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.sispeaId}
                            value={collectivity.idSispea}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, idSispea: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.name}
                            value={collectivity.name}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, name: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Select
                            label={i18n.type}
                            value={collectivity.id}
                            options={[{ name: collectivity.type, id: collectivity.id }]} // change with real options
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, type: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={`N° ${i18n.siren}`}
                            value={collectivity.numberSiren}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, numberSiren: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={`N° ${i18n.insee}`}
                            value={collectivity.numberInsee}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, numberInsee: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.memberMunicipalities}
                            value={collectivity.municipality}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, municipality: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Checkbox
                            label={i18n.withCCSPL}
                            checked={collectivity.withCCSPL}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, withCCSPL: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Checkbox
                            readMode={readMode}
                            label={i18n.production}
                            checked={collectivity.production}
                            onChange={v => setCollectivity(prev => ({ ...prev, production: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Checkbox
                            label={i18n.transfer}
                            checked={collectivity.transfert}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, transfer: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Checkbox
                            label={i18n.distribution}
                            checked={collectivity.distribution}
                            readMode={readMode}
                            onChange={v => setCollectivity(prev => ({ ...prev, distribution: v }))}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.nbManagementEntities}
                            value={nbManagementEntities.toString()}
                            readMode
                        />
                    </Grid2>
                </Grid2>

            </CardContent>
        </Card>
    )
}

CollectivityForm.propTypes = {
    collectivity: PropTypes.shape({}),
    readMode: PropTypes.bool,
    nbManagementEntities: PropTypes.number,
    setCollectivity: PropTypes.func,
}

export default CollectivityForm
